import { useQueryClient } from '@tanstack/react-query'
import { useTeam } from 'app/frontend/base/config/context/team'
import useReferenceStore from 'app/frontend/base/state/useReferenceStore'
import { patchTeamEventReferenceCaches } from '../utils/teamEventReferenceCache'

const useApplyEventUpdate = () => {
  const queryClient = useQueryClient()
  const { team } = useTeam()
  const { storeReferences } = useReferenceStore()

  return (event: wowaudit.Event) => {
    queryClient.setQueryData(
      ['teamEvent', { teamId: team.id, eventId: event.id }],
      event,
    )
    patchTeamEventReferenceCaches(queryClient, team.id, event)
    storeReferences([event])
  }
}

export default useApplyEventUpdate
